import { Button } from 'antd'
import styled from 'styled-components'

const StyledRetryButton = styled(Button)`
  &:hover,
  &:focus {
    color: red;
    border-color: red;
  }
`

export default StyledRetryButton
